"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandMapAdvertisementBlockToJSON = exports.BrandMapAdvertisementBlockFromJSONTyped = exports.BrandMapAdvertisementBlockFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function BrandMapAdvertisementBlockFromJSON(json) {
    return BrandMapAdvertisementBlockFromJSONTyped(json, false);
}
exports.BrandMapAdvertisementBlockFromJSON = BrandMapAdvertisementBlockFromJSON;
function BrandMapAdvertisementBlockFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'image': !(0, runtime_1.exists)(json, 'image') ? undefined : (0, _1.AssetFromJSON)(json['image']),
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
    };
}
exports.BrandMapAdvertisementBlockFromJSONTyped = BrandMapAdvertisementBlockFromJSONTyped;
function BrandMapAdvertisementBlockToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'image': (0, _1.AssetToJSON)(value.image),
        'url': value.url,
    };
}
exports.BrandMapAdvertisementBlockToJSON = BrandMapAdvertisementBlockToJSON;
